function val(obj, key) {
    const val = obj[key];
    return typeof val === "string"
        ? val.toLowerCase()
        : val;
}

const propertyComparatorBuilder = (...keys) => (a, b) => {
    if (a === b) return 0;
    if (a == null) return b == null ? 0 : -1;
    if (b == null) return 1;
    for (const k of keys) {
        const x = val(a, k);
        const y = val(b, k);
        if (x == null && y != null) return -1;
        if (x != null && y == null) return 1;
        if (x < y) return -1;
        if (x > y) return 1;
    }
    return 0;
};

export default propertyComparatorBuilder;



// WEBPACK FOOTER //
// ./app/data/util/propertyComparatorBuilder.js